export const waiting = 2000
export const OK = 200
export const SUCCESS = 201

// http(s)://upload-z2.qiniup.com
export const qiniuUploadUrl = 'https://upload-z2.qiniup.com'

export const filePrefix = 'https://oss.cloudcpc.com'
// export const filePrefix = 'https://tunhaohuo.top'

export const regTel = /^1[3456789]\d{9}$/
export const regCard = /(^\d(15)$)|((^\d{18}$))|(^\d{17}(\d|X|x)$)/

// 正整数
export const regNumLgtZero = /^[0-9]\d*$/

// 两位小数的数字
export const regStock = /^[0-9]+(.[0-9]{1,2})?$/
